import { useState, useEffect } from "react";
import Menu from "../components/Menu";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import { Lightbox } from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/plugins/captions.css";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";

export default function Gallery() {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const [photos, setPhotos] = useState([]);
  const API_BASE = "https://tomaszfotograf.pl";

  useEffect(() => {
    const fetchPhotos = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/photos`);
        if (!res) throw new Error("Błąd pobierania danych z API");
        const data = await res.json();
        const prepared = data.map((item) => {
          const date =
            item.timestamp && !isNaN(item.timestamp)
              ? new Date(item.timestamp * 1000)
              : null;
          return {
            ...item,
            fullSrc: `${API_BASE}${item.fullUrl}`,
            miniSrc: `${API_BASE}${item.miniUrl}`,
            dateTaken: date,
          };
        });

        prepared.sort((a, b) => {
          if (!a.dateTaken && !b.dateTaken) return b.name.localeCompare(a.name);
          if (!a.dateTaken) return 1;
          if (!b.dateTaken) return -1;
          return b.dateTaken - a.dateTaken;
        });

        setPhotos(prepared);
      } catch (err) {
        console.error("Błąd:", err);
      } finally {
        console.log("ok");
      }
    };

    fetchPhotos();
  }, []);

  return (
    <>
      <Menu />
      <div className="fullpage">
        <section className="section section-dark images-row">
          {photos.map(
            ({ miniSrc, dateTaken }, realIndex) =>
              realIndex < 150 && (
                <motion.div
                  key={miniSrc}
                  style={{
                    textAlign: "center",
                    flex: "0 0 25.00%",
                    boxSizing: "border-box",
                    padding: "0px",
                  }}
                  initial={{ opacity: 0, y: 50, scale: 0.9 }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  transition={{
                    delay: 0.3 + realIndex * 0.15,
                    duration: 0.7,
                    ease: "easeOut",
                  }}
                >
                  <img
                    src={miniSrc}
                    alt={`miniatura-${realIndex}`}
                    style={{
                      width: "100%",
                      maxWidth: 450,
                      height: "auto",
                      objectFit: "cover",
                      cursor: "pointer",
                      padding: 0,
                      background: "#fff",
                      borderRadius: 0,
                      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      transition: "transform 0.2s",
                    }}
                    onClick={() => {
                      setIndex(realIndex);
                      setOpen(true);
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "scale(1.0)")
                    }
                  />
                </motion.div>
              )
          )}
        </section>
      </div>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={photos.map((p) => ({
          src: p.fullSrc,
        }))}
        plugins={[Captions, Slideshow, Zoom]}
        zoom={{
          maxZoomPixelRatio: 3,
          zoomInMultiplier: 2,
          doubleTapDelay: 300,
          scrollToZoom: true,
        }}
        slideshow={{ autoplay: false, delay: 4000 }}
      />
      {/*
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        index={index}
        slides={photos.map((p) => ({ src: p.fullSrc }))}
        controller={{ closeOnBackdropClick: true }}
        animation={{
          fade: 400,
          swipe: 0,
          navigation: 400,
          easing: {
            navigation: "easeInOut",
            fade: "easeInOut",
          },
        }}
        render={{
          slide: ({ slide }) => (
            <motion.img
              src={slide.src}
              style={{
                width: "90%",
                height: "90%",
                objectFit: "contain",
                position: "relative",
                top: 100,
                left: 100,
                right: 100,
              }}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.2 }}
            />
          ),
        }}
        plugins={[Zoom]}
      />
      */}
    </>
  );
}
